import axios from "axios";
import { BASE_URL, Urls } from "../../slices/urls";

export const getFooterPwaRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_FOOTER_PWA_API,
    params: params,
    // headers: {
    //   domain: window.location.host,
    // },
  });
};

export const getHeaderDataRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_HEADER_API,
    params: data,
  });
};

export const getHeaderSearchDataRepo = (params) => {
  return axios({
    method: "GET",
    url: window?.origin + `/generic-search/autocomplete/${params}`,
  });
};

export const getTrendingSearchRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_TRENDING_SEARCH_API,
    params: params,
  });
};

export const get404UrlCheckRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_404_URL_CHECK,
    params: params,
  });
};

export const getStreamLevelCombinationRepo =(params)=>{
  return axios({
    method:"GET",
    url:Urls.GET_STREAM_LEVEL_COMBINATION_API,
    params:params,
  });
};
